import { render, staticRenderFns } from "./AMCMockTest.vue?vue&type=template&id=2c3954e5&scoped=true"
import script from "./AMCMockTest.vue?vue&type=script&lang=js"
export * from "./AMCMockTest.vue?vue&type=script&lang=js"
import style0 from "./AMCMockTest.vue?vue&type=style&index=0&id=2c3954e5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c3954e5",
  null
  
)

export default component.exports